<template>
<div>
    <FeaturesSaveButton
        :disabled='(![LOCATION_VALUE] && !address) || ([LOCATION_VALUE] && location === address)'
        @click='setLocationHandler'>
    </FeaturesSaveButton>

    <div class='h-text-center h-mv-20'>
        <div class='b-base-title h-mt-10'>
            {{ $t('EVENT.NAME.LOCATION') }}
        </div>
    </div>
    <div>
        <form class='h-mt-15'>
            <FwFormInput
                class='h-mb-25'
                :fieldHasError='fieldHasErrorByRule(location_value || ``, LOCATION_VALUE, locationRules)'
                labelType='label-thin'
                :title='$t("EVENT.NAME.LOCATION")'>
                <div style='min-width: 120px; height: 60px'>
                    <div class='b-location-input'>
                        <div style='width: 100%' class='fw-select-base'>
                            <SelectAddress
                                :startAddress='address'
                                placeholderText='EVENT.NAME.LOCATION'
                                @changePostCode='value => post_code = value'
                                @input='input'>
                            </SelectAddress>
                        </div>
                    </div>
                    <div v-if='location && !isCleared'
                         class='b-location-input__clean'
                         @click='cleanAddress'>
                        {{ $t('BUTTON.DELETE') }}
                    </div>
                </div>
            </FwFormInput>
        </form>
    </div>
</div>
</template>

<script lang='ts'>
import { Component, Emit, mixins, Prop, Watch, Vue } from 'vue-facing-decorator';
import { useValidation } from '@/composables/useValidation';
import { LOCATION_VALUE } from '@/helpers/events';
import { FeaturesSaveButton } from '@/components/forms/features/FeaturesSaveButton';
import { SelectAddress } from '@/components/common/SelectAddress';
import { ParsedAddressData } from '@/types/GoogleMap';

@Component({
    emits: ['click', 'setLocation'],
    components: {
        FeaturesSaveButton,
        SelectAddress,
    },
})
export default class LocationFeature extends Vue {
    @Prop({
        // @ts-ignore
        validator: prop => typeof prop === `string` || prop === null,
        required: true,
    }) readonly location!: string | null;

    options: Array<string> = [];
    [LOCATION_VALUE]: string | null = '';
    LOCATION_VALUE: string = LOCATION_VALUE;
    locationRules: string[] = ['required', 'minLength:2', 'maxLength:100'];

    validation = useValidation();

    get fieldHasErrorByRule() {
        return this.validation.fieldHasErrorByRule;
    }

    get getFieldErrorTextByRule() {
        return this.validation.getFieldErrorTextByRule;
    }

    get clearServerErrorsBase() {
        return this.validation.clearServerErrorsBase;
    }

    get addCurrentInputToValidateArray() {
        return this.validation.addCurrentInputToValidateArray;
    }

    get isFormValid() {
        return this.validation.baseInputValidator({ value: this[LOCATION_VALUE] || ``, minLength: 2 });
    }

    isSaveButtonShow: boolean = false;
    autocompleteService: any = null;
    country: string = '';
    address: string = '';
    post_code: string = '';
    calizyAddress: string = '';

    created() {
        if (this.location) {
            this[LOCATION_VALUE] = this.location;
            this.address = this.location;
        }
    }

    // @ts-ignore-next-line
    input(parsedAddressData: ParsedAddressData) {
        if (!parsedAddressData) {
            this.cleanAddress();
            return;
        }

        this.post_code = parsedAddressData.post_code;
        this.address = parsedAddressData.address;
        this.country = parsedAddressData.country;
        this.calizyAddress = parsedAddressData.calizyAddress;

        if (!this.post_code || !this.country) {
            this.sentNotif('EVENT.NAME.LOCATION.NO.POSTCODE');
        }
    }

    get isCleared() {
        return (
            !this.calizyAddress &&
            !this.post_code &&
            !this.address &&
            !this.country
        );
    }

    cleanAddress() {
        this.calizyAddress = '';
        this.post_code = '';
        this.address = '';
        this.country = '';
    }

    @Watch('address')
    checkLocationValue() {
        if (this.address !== this[LOCATION_VALUE]) {
            if (this.address && this.post_code && this.country) {
                this.isSaveButtonShow = true;
            }
            const locationData = {
                title: this.address,
            };
            this.$emit('click', locationData);
        } else {
            this.isSaveButtonShow = false;
        }
    }

    @Emit('setLocation')
    setLocationHandler() {
        if (!this.address) {
            return '';
        }

        return this.calizyAddress;
    }
}
</script>

<style lang='sass'>
.pac-container
    display: none !important

.b-location-input
    &__clean
        display: flex
        align-items: center
        justify-content: flex-end
        width: 100%
        margin-top: 6px
        font-size: 14px
        color: #203f6a
        cursor: pointer

        &:hover
            opacity: 0.7

    .multiselect__tags
        overflow-x: hidden
        text-overflow: ellipsis
        border-radius: 10px !important
        border: none !important

        .multiselect__input
            white-space: nowrap
            overflow-x: hidden
            text-overflow: ellipsis

        .multiselect__single
            display: block
            min-height: 0
            white-space: nowrap
            overflow-x: hidden
            text-overflow: ellipsis

    .multiselect__content-wrapper
        overflow: hidden!important
        margin-top: 40px
        background: #fff !important

    .multiselect__content
        width: 100%

        li
            border-radius: 10px
            margin: 10px 0
            overflow-x: hidden
            text-overflow: ellipsis

            span
                white-space: nowrap
                overflow-x: hidden
                text-overflow: ellipsis

        li:last-child
            opacity: 0
</style>
